import React from 'react';
import styled from 'styled-components';
import { FaGithub, FaTwitter, FaDiscord } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.surface};
  padding: 2rem;
  text-align: center;
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 1rem;
`;

const SocialLink = styled.a`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 1.5rem;
  transition: ${({ theme }) => theme.transitions.default};
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    transform: translateY(-2px);
  }
`;

const Copyright = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 0.9rem;
  margin: 0;
  
  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Divider = styled.div`
  height: 1px;
  background: linear-gradient(
    to right,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  margin: 1rem 0;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <SocialLinks>
          <SocialLink 
            href="https://github.com/yourusername/raffle-game" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <FaGithub />
          </SocialLink>
          <SocialLink 
            href="https://twitter.com/yourhandle" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Twitter"
          >
            <FaTwitter />
          </SocialLink>
          <SocialLink 
            href="https://discord.gg/yourinvite" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Discord"
          >
            <FaDiscord />
          </SocialLink>
        </SocialLinks>
        
        <Divider />
        
        <Copyright>
          &copy; {currentYear} Raffle TV. All rights reserved. | 
          <a href="/terms" target="_blank" rel="noopener noreferrer">Terms</a> | 
          <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        </Copyright>
        
        <Copyright style={{ fontSize: '0.8rem', opacity: 0.7 }}>
          Raffle TV is a decentralized application. Please ensure you understand the risks before participating.
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
